import {
  ColumnOptionsModel,
  ListOptionsColumnsStep,
} from './list-options-columns-step.controller';

export type { ColumnOptionsModel };

export interface ListOptionsFormControllerProps {
  columnOptions: ColumnOptionsModel;
  columnLabelMap: Record<string, string>;
  onChange: (columnOptions: ColumnOptionsModel) => void;
}

export const ListOptionsFormController = ({
  columnOptions,
  columnLabelMap,
  onChange,
}: ListOptionsFormControllerProps): React.JSX.Element => {
  return (
    <ListOptionsColumnsStep
      columnOrder={columnOptions.columnOrder}
      columnVisibility={columnOptions.columnVisibility}
      columnLabelMap={columnLabelMap}
      onChange={onChange}
    />
  );
};
